
import * as Components from "./Leonorsvegetarian"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "leonorsvegetarian"
}

